// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"skeletonBox-module__skeletonContainer__JIpdj","shimmer":"skeletonBox-module__shimmer__2GVET","skeletonBox":"skeletonBox-module__skeletonBox__ua1sW"};